export default "__VITE_ASSET__Df_H2_WX__"